module.exports = __webpack_public_path__ + "img/纯净模式@2x.664c7958.png";